import React from "react";
import PropTypes from 'prop-types';
import { Row, Col, Card, FormText } from "reactstrap";
import TimePickerAtom from "atoms/TimePickerAtom";
import styles from "components/styles.module.scss";
import { BEHAVIOUR } from 'helpers/constants';
import { getLocalizedText } from 'helpers/language';

const TimeSelectComponent = (props) => {
  const { data, index, isResponseWrong, language, errors } = props;
  const selectedOption = data.selectedOption;

  return (
    <Card
      className={
        isResponseWrong
          ? `${styles["highlight-div"]} ${styles["card-ui"]} m-3 p-3`
          : `${styles["card-ui"]} m-3 p-3`
      }
    >
      <Row>
        <Col md={11} className={`${styles["custom-col"]} ps-1`}>
          <span>
            <span>
              {data.behaviour === BEHAVIOUR.MANDATORY ? "*" : null}
            </span>
            {index + 1}.
          </span>
          <div
            className={
              data.behaviour === BEHAVIOUR.MANDATORY
                ? `${styles["questions-ui"]} pe-0 ps-2`
                : "ps-2"
            }
            dangerouslySetInnerHTML={{
              __html: getLocalizedText(language, data.question, data.sp_question),
            }}
          ></div>
        </Col>
      </Row>
      <div className="mt-2">
        <Row>
          <Col>
            <TimePickerAtom
              id={`time_${index}`}
              name={`time_${index}`}
              submitEditedTime={props.submitStartTime}
              onChange={(val) =>
                data.setSelectedOption({
                  ...(selectedOption?.[0] || {}),
                  time: val,
                })
              }
            />
          </Col>
        </Row>
      </div>
      <div>
        <FormText className={styles["error-text"]} color="danger">
          {errors}
        </FormText>
      </div>
    </Card>
  );
};

TimeSelectComponent.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isResponseWrong: PropTypes.bool,
  errors: PropTypes.string,
  language: PropTypes.string,
  submitStartTime: PropTypes.func,
};

export default TimeSelectComponent;
